import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dinein-food',
  templateUrl: './dinein-food.component.html',
  styleUrls: ['./dinein-food.component.css']
})
export class DineinFoodComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
